const CompanyTypes = {
    SALE_ACTION_START:"SALE_ACTION_START",
    SALE_FETCH_DATA:"SALE_FETCH_DATA",
    SALE_FETCH_DATA_FAILED:"SALE_FETCH_DATA_FAILED",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
}

const SaleReducer = (state=Initial_state, action) => {
    switch(action.type){
        case CompanyTypes.SALE_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case CompanyTypes.SALE_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload,
            }

        case CompanyTypes.SALE_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }
        default:
            return state;
    }
};

export default SaleReducer;